import { graphql } from "@/gql";

export const refundPaymentMutation = graphql(`
  mutation RefundPaymentMutation($id: ID!, $amount: Int!, $reason: String!) {
    refundPayment(id: $id, amount: $amount, reason: $reason) {
      id
    }
  }
`);
